
import $ from 'jquery'
// http://mmenu.frebsite.nl/
import 'jquery.mmenu'

export default function () {
  var $nav = $('#mobile-nav')

  // Prevent mmenu plugin to start if it doesn't exist
  if (!$nav.length) {
    return
  }

  $('#mobile-nav').mmenu({
    slidingSubmenus: false,
    'extensions': [
      'border-none'
    ],
    navbar: {
      add: false
    },
    'offCanvas': {
      'zposition': 'top',
      'position': 'top'
    }
  })

  var api = $nav.data('mmenu')

  $('.close-panel').click(function (e) {
    e.preventDefault()
    api.close()
  })
}



// WEBPACK FOOTER //
// ./scripts/lib/mobile-nav.js